import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchEventsConfig } from '@v2/pages/batch/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsBatchEventsStack = createStackNavigator();

const BatchDetailsBatchEventsNavigator = (props: any) => {
  return (
    <BatchDetailsBatchEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchEventsConfig.map(({ Component, name }) => (
        <BatchDetailsBatchEventsStack.Screen key={name} name={name} component={Component} initialParams={props.route?.params} />
      ))}
    </BatchDetailsBatchEventsStack.Navigator>
  );
};

export { BatchDetailsBatchEventsNavigator };
